module.exports = __webpack_public_path__ + "img/goodfellow.229af012.jpeg";